import setPrototypeOf from "./setPrototypeOf.js";
export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}


//////////////////
// WEBPACK FOOTER
// ../~/@babel/runtime/helpers/esm/inheritsLoose.js
// module id = 194
// module chunks = 0